export enum BottleSizeEnum {
  PICCOLO = 1875,
  CHOPINE = 2500,
  HALF = 3750,
  JENNIE = 5000,
  CLAVELIN = 6200,
  SPIRIT = 7000,
  BOTTLE = 7500,
  LITRE = 10000,
  MAGNUM = 15000,
  MARIE_JEANNE = 22500,
  DOUBLE_MAGNUM = 30000,
  REHOBOAM = 45000,
  JEROBOAM = 50000,
  IMPERIALE = 60000,
  SALMANAZAR = 90000,
  BALTHAZAR = 120000,
  NEBUCHADNEZZAR = 150000,
  MELCHIOR = 180000,
  SOLOMON = 200000,
  SOVEREIGN = 260000,
  PRIMAT = 270000,
  MELCHIZEDEK = 300000,
  MAXIMUS = 1300000,
}
